/** Parse MissingInfoFor CSV field into grant record IDs */
export function parseMissingInfoFor(value) {
  if (!value) return [];
  return value.split(',').map((item) => item.trim()).filter(Boolean);
}

/** Add a grant record ID to MissingInfoFor CSV (no duplicates) */
export function addGrantIdToMissingInfoFor(currentValue, grantId) {
  if (!grantId) return currentValue || '';
  const ids = parseMissingInfoFor(currentValue);
  if (ids.includes(grantId)) return ids.join(',');
  return [...ids, grantId].join(',');
}

/** Remove a grant record ID from MissingInfoFor CSV */
export function removeGrantIdFromMissingInfoFor(currentValue, grantId) {
  if (!grantId) return currentValue || '';
  return parseMissingInfoFor(currentValue).filter((id) => id !== grantId).join(',');
}
